'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidIncrementsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidIncrementsRemote = exports.BidIncrementsRemote = {
    fetchBidIncrements: function fetchBidIncrements(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/bid-increments', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ catalogIds: [catalogId] });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/bidIncrements.js
// module id = 5A1c
// module chunks = 46